//#region Libraries
import styled from "styled-components";
import { Link } from "react-router-dom";
//#endregion

export const Container = styled.tr`
    margin: 5px 0;
    width: 100%;
    line-height: 30px;
    &.is-past * {
        color: var(--purple-4) !important;
        pointer-events: none;
        svg path {
            fill: var(--purple-4) !important;
        }
    }
`;
export const TDef = styled.td`
    margin: 0;
    padding: 0;
`;
export const TDefContent = styled.div`
    background-color: var(--light-1);
    height: 110px;
    width: 100%;
    margin: ${({ margin = "4px 0" }) => margin};
    padding: ${({ padding = "20px 12px"  }) => padding};
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    transition: 0.3s;
    & h4 {
        margin: 0;
        color: var(--light-gray-5);
        &[data-role="no-data"] {
            font-size: 13px;
        }
    }
    & h5 {
        margin: 0;
        color: var(--light-gray-5);
        font-weight: 400;
        font-size: 14px;
        text-align: center;
    }
    &.small {
        height: 52px;
        padding: 14px 32px;
    }
    &.stand-out {
        border-radius: 4px;
        border-left: 8px solid transparent;
        &.yes {
            border-left-color: var(--red-1);
        }
        &.no {
            border-left-color: var(--purple-4);
        }
        & h5 {
            font-weight: bold;
        }
    }
    &.ellipsis {
        & h3, h5 {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
`;
export const NameCell = styled(TDefContent)`
    justify-content: ${({ justify = "space-evenly" }) => justify};
    min-width: 300px;
    gap: 8px;
    padding-left: 20px;
    & h3 {
        margin: 0;
        font-size: 16px;
        width: 330px;
    }
    & > div {
        display: flex;
        align-items: center;
        gap: 10px;
    }
    & span {
        color: var(--light-gray-4);
        line-height: 20px;
        &[data-role="enrolled"] {
            font-size: 12px;
            border-radius: 4px;
            padding: 0 8px;
            min-width: max-content;
            border-radius: 4px;
            border: 1px solid var(--light-gray-4);
        }
        &[data-role="created-date"] {
            font-size: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 50%;
            display: block;
        }
    }
    &.small {
        & h5 {
            text-align: start;
        }
        &.is-past h5 {
            color: var(--purple-4);
        }
    }
`;
export const DaysCell = styled(TDefContent)`
    min-width: 140px;
    align-items: center;
    ul {
        display: flex;
        list-style: none;
        gap: 5px;
        margin: 0;
        padding: 0;
        li {
            font-size: 12px;
            font-weight: bold;
            &:not(.taken) {
                color: var(--light-blue-3);
            }
        }
    }
`;
export const TimeCell = styled(TDefContent)`
    min-width: 120px;
    &.is-past h5 {
        color: var(--purple-4);
    }
`;
export const TeacherNameCell = styled(TDefContent)`
    min-width: 170px;
    align-items: center;
    line-height: 18px;
    & h5 {
        text-align: center;
        max-width: 170px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100%;
    }
`;
export const LocationCell = styled(TDefContent)`
    min-width: 200px;
    align-items: center;
    line-height: 18px;
    & h5, & h4 {
        text-align: center;
        max-width: 200px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100%;
    }
`;
export const ProgrammingCell = styled(TDefContent)`
    justify-content: center;
    align-items: center;
    line-height: 18px;
    & h5 {
        text-align: center;
        max-width: 340px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100%;
    }
    &.is-past h5 {
        color: var(--purple-4);
    }
`;
export const ActionsCell = styled(TDefContent)`
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    gap: 15px;
    min-width: ${({ minWidth = "250px" }) => minWidth};
    & .offset {
        width: 90px;
    }
`;
export const LinkAction = styled(Link)`
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    color: var(--purple-2);
    transition: 0.4s;
    width: max-content;
    min-width: ${({ minwidth = "unset" }) => minwidth};
    text-align: center;
    &:hover {
        color: var(--purple-1);
    }
    &.disabled {
        color: var(--purple-4);
        pointer-events: none;
        cursor: default;
    }
`;
export const DeleteButton = styled.button`
    display: flex;
    align-items: center;
    padding: 3px;
    border-radius: 5px;
    border: 0;
    background-color: transparent;
    cursor: pointer;
    transition: 0.35s;
    & svg {
        width: 23px;
        height: 23px;
    }
    & path {
        transition: 0.35s;
    }
    &:not(:disabled) {
        &:hover {
            backdrop-filter: brightness(90%);
        }
    }
    &:disabled {
        cursor: default;
        svg path {
            fill: var(--purple-4);
        }
    }
`;
export const CellTableContentDetails = styled.div`
    overflow: hidden;
    height: 0px;
    margin: 0 6px;
    display: flex;
    flex-direction: column;
    gap: 30px;
    border: 1px solid transparent;
    background-color: var(--light-1);
    transition: 0.4s;
    opacity: 0;
    &.opened {
        opacity: 1;
        padding: 30px 0;
        transition: 0.4s;
        height: auto;
        border-color: var(--light-gray-8);
    }
`;
export const Field = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    & span {
        font-size: 14px;
        color: var(--light-gray-5);
    }
    &.disabled {
        & span {
            color: var(--purple-4);
        }
    }
`;